import { Eye, Pencil, Trash2 } from 'lucide-react';
import * as React from 'react';
import Avatar from '../../../../components_v2/avatar/Avatar';
import { CARD_AVATAR_SIZE, Card, CardActions, CardBody, CardIconButton, CardImage, CardText, CardTitle, ColorBar } from './style/LinkedElementStyle';

export function CardAvatar(props: { photo?: string | null, name: string, userId?: number, backgroundColor?: string }): JSX.Element {
	if (props.photo) return <CardImage url={props.photo} />;
	return <Avatar width={CARD_AVATAR_SIZE} fontSize='10px' name={props.name} userId={props.userId} backgroundColor={props.backgroundColor} />;
}

function stopPropagation(fn: () => void) {
	return (e: React.MouseEvent) => {
		e.stopPropagation();
		fn();
	};
}

export function CardEditButton(props: { onClick: () => void }): JSX.Element {
	return <CardIconButton type='button' onClick={stopPropagation(props.onClick)}><Pencil size={14} color='currentColor' /></CardIconButton>;
}

export function CardDeleteButton(props: { onClick: () => void }): JSX.Element {
	return <CardIconButton type='button' onClick={stopPropagation(props.onClick)}><Trash2 size={14} color='currentColor' /></CardIconButton>;
}

export function CardViewButton(props: { onClick: () => void }): JSX.Element {
	return <CardIconButton type='button' onClick={stopPropagation(props.onClick)}><Eye size={14} color='currentColor' /></CardIconButton>;
}

export default function LinkedElementCard(props: {
	isExtend?: boolean
	color?: string
	avatar?: React.ReactNode
	title: React.ReactNode
	lines?: React.ReactNode[]
	children?: React.ReactNode
	actions?: React.ReactNode
	onClick?: () => void
}): JSX.Element {
	return <Card isExtend={props.isExtend ?? false} onClick={props.onClick}>
		{props.color && <ColorBar color={props.color} />}
		{props.avatar}
		<CardBody>
			<CardTitle>{props.title}</CardTitle>
			{props.lines?.map((line, i) => <CardText key={i}>{line}</CardText>)}
			{props.children}
		</CardBody>
		{props.actions && <CardActions>{props.actions}</CardActions>}
	</Card>;
}
